"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var styles_1 = __importDefault(require("./styles"));

var Card = function Card(_a) {
  var loading = _a.loading,
      className = _a.className,
      children = _a.children;
  return react_1.default.createElement("div", {
    className: classnames_1.default('card', className)
  }, react_1.Children.map(children, function (child) {
    return react_1.cloneElement(child, {
      loading: loading
    });
  }));
};

var cardImageStyle = function cardImageStyle(loading, src) {
  if (loading || !src) return {};
  return {
    backgroundImage: "url(" + src + ")"
  };
};

exports.CardImage = styles_1.default(function (_a) {
  var children = _a.children,
      className = _a.className,
      classes = _a.classes,
      src = _a.src,
      loading = _a.loading,
      size = _a.size,
      props = __rest(_a, ["children", "className", "classes", "src", "loading", "size"]);

  var _b, _c;

  return react_1.default.createElement("div", __assign({
    className: classnames_1.default(classes.cardImg, (_b = {}, _b[classes.animatedBackground] = loading, _b), size && (_c = {}, _c[classes[size]] = true, _c), className),
    style: cardImageStyle(loading, src)
  }, props), children);
});
exports.CardBody = styles_1.default(function (_a) {
  var className = _a.className,
      classes = _a.classes,
      loading = _a.loading,
      title = _a.title,
      text = _a.text,
      children = _a.children;

  var _b, _c;

  return react_1.default.createElement("div", {
    className: classnames_1.default('card-body', className)
  }, title ? react_1.default.createElement("h5", {
    className: classnames_1.default('card-title', (_b = {}, _b[classes.animatedBackground] = loading, _b))
  }, title) : '', text ? react_1.default.createElement("p", {
    className: classnames_1.default('card-text', (_c = {}, _c[classes.animatedBackground] = loading, _c))
  }, text) : '', children);
});
exports.default = Card;